import ImageComponentPlugin from './components/ImageComponentPlugin';
import AudioComponentPlugin from './components/AudioComponentPlugin';
import VideoComponentPlugin from './components/VideoComponentPlugin';
import AttachmentComponentPlugin from './components/AttachmentComponentPlugin';
import type { AhaSlateEditor, EditorPlugin } from '../../types/aha-editor';
import ToolInsertMedia from './tools/ToolInsertMedia';
import {
  AttachmentSchemaPlugin,
  AudioSchemaPlugin,
  ImageSchemaPlugin,
  VideoSchemaPlugin,
} from './MediaSchemaPlugin';
import preferHTMLContent from '../../util/preferHTMLContent';
import type AhaEditorV2Controller from '../../controllers/AhaEditorV2Controller';

// Paste or drop for image/video/audio.
const MediaTransferDataPlugin: EditorPlugin = {
  name: 'Media transfer data plugin',
  dependencies: [
    AudioComponentPlugin,
    ImageComponentPlugin,
    VideoComponentPlugin,
  ],
  insertData: (
    editor: AhaSlateEditor,
    data: DataTransfer,
    controller: AhaEditorV2Controller
  ) => {
    const htmlContent = data.getData('text/html');
    if (htmlContent?.match('OneNote.File')) return false;

    const mediaProvider = controller?.ahaEditor.getProvider('media');

    if (!mediaProvider?.canAddAttachments) {
      return false;
    }

    // Check if we should prefer HTML (e.g., for OneNote or Excel content)
    if (preferHTMLContent(data)) {
      return false; // Let HTML paste plugin handle this
    }

    for (const item of data.items) {
      if (item.kind === 'file') {
        const file: File | null = item.getAsFile();
        if (!file) {
          console.warn('Unable to get file from data transfer item.');
          return false;
        }

        void ToolInsertMedia.insertMediaFromFile(editor, file);
        return true;
      }
    }

    return false; // This plugin didn't handle the type of data.
  },
};

// Plugin for media (image, audio, video) that is uploaded and served by Aha!
const MediaPlugin = [
  ImageComponentPlugin,
  AudioComponentPlugin,
  VideoComponentPlugin,
  AttachmentComponentPlugin,
  ImageSchemaPlugin,
  AudioSchemaPlugin,
  VideoSchemaPlugin,
  AttachmentSchemaPlugin,
  MediaTransferDataPlugin,
];

export default MediaPlugin;
